module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_66-b1e084b36a055e3c73c242ae52d3ca03.png";